var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 19,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_446_55",
    transform: "translate(0 -0.105263) scale(0.01 0.0121053)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_446_55",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAADT0lEQVR4nO3dO2sVQRjG8f/rlaBWoqCmUSN4AyERSyuxNTHfQmxEokGx0UJiOj+Hl0T8Agpi4QWxsFCihUZLIUTxgo7FHtvM7J7J5D27z6+enfOe8zA7s2fPngEREREREZGyrMlBIYRNwARwBhgFhoEtGesaRN+AT8BLYA6YM7NfdTupHUgIYRK4Beyre2zHLABTZna/zkHJgYQQ1gMzwMWahXXdLDBtZn9TGm+o0bHCaGYKCMDllMZJI6R3mrrTR1ECE2Y2F2sUDaQ3gb8B9ueoqsM+AAdjE/26hI4mUBg57KVala4oJZDx/muRniyBjGUoRCrHYw1SAtmVoRCp7Ik1SJnUQ55aBMDMVvzMU0aIFKRAnFEgzigQZxSIMwrEGQXijAJxRoE4U+cGVZu8Bu4Cj4AvwCLwE9gG7ARGgJPAaeAYDX970ETXvjp5BZwzs6epB4QQjgDXgbM5Coh9ddKlQG4C18zsT5ODc30OsUC6csqaMbMra11Eii6MkHtmNtlvJ6VGSNsDWQIOm9livx2VCqTty97bOcIoqc0jJAAHzGwhS2caIX17nCuMktocyJO1LqCJNi97n6U2DCEcBc4DJ4AdwHZgaJXqWlGbA3mb0iiEcAp4CGxe3XLStPmU9TWx3Q2chAHtXmUNmdmPWKMQwncKnp46e2EYe+P/lX5/XV72DiQF4owCcUaBOKNAnBnYC8PUVVSOfkIIu6nuu686jZA0xR5aUiBpFIgz0UfRclEgaUZLvZACiehN6MWes1QgcUWfQlYgcQrEmWITOiiQFMUmdBjgK/XYfQyv90NiNEKcUSDOKBBnFIgzCsQZBeKMAnFGgTijQJxRIM4oEGcUiDMKxBkF4owCcUaBOKNAnFEgzigQZxSIMwrEGQXijAJxJiWQ5VWvojuWYg1SAvmcoRCpRD/LlECeZyhEKtF/KEoJZD5DIVJ5EGuQ8gTqRqqNJUdyVFSKw9/2vgcO9b2xpJn9Bi7lqqqjAnAhZTvvpGVvbwvq2X6rKikkKlTOjJlFT1dQ7zpkmmofdUkXqHbZvpp6QJMN7sepRstAzSlr4B3VBve1FkWN/p6iN9GPU+3tOgYMA1ub9NUiy8BH4AXVynS+N/+KiIiIiIi49g9UHeNWNGeDYgAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.a099f74c97f862a9b39eb948d3a27aab.svg";
export { ForwardRef as ReactComponent };